// client/src/coms/e2ee/ServerEncryptionBadge.js
// "Standard Server" / "Encrypted Server" under the server's name: the server's policy, not a claim that this device
// can read or send encrypted messages (each channel shows that itself).
import React from 'react';
import { useServerE2ee } from './serverE2eeClient';
import './e2ee.css';

export default function ServerEncryptionBadge({ serverKey }) {
  const { data } = useServerE2ee(serverKey);
  if (!data) return null;
  const on = data.encryption === 'on';
  const action = !!data.pending_ack;
  const title = on
    ? 'Encrypted Server: supported messages are end-to-end encrypted. Voice, attachments, bots and some other features are not.'
    : 'Standard Server: messages are not end-to-end encrypted.';
  return (
    <span className={`vx-e2ee-server-badge${on ? ' is-on' : ''}${action ? ' is-action' : ''}`} title={title} data-testid="server-e2ee-badge" data-e2ee={on ? 'on' : 'off'}>
      {on ? '🔒 Encrypted Server' : 'Standard Server'}
      {action ? ' · action needed' : ''}
    </span>
  );
}
